// extracted by mini-css-extract-plugin
var _1 = "rvgIaDehBpBCkL8kBQLh";
var _2 = "rvgIaDehBpBCkL8kBQLh";
var _3 = "LoNtN0mu28URNwBKRNh8";
export { _1 as "download-button", _2 as "downloadButton", _3 as "heading" }
